import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductConfigurationService } from '@fleet/product-configuration';
import { MarkdownComponent } from 'ngx-markdown';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'fleet-change-log',
    imports: [CommonModule, MarkdownComponent],
    template: `
    <div
      #content
      class="prose max-w-none"
      style="margin: 0 auto; max-width: 800px; padding: 20px"
    >
      <img
        [src]="logoSrc"
        alt="Logo"
        class="w-auto h-auto max-h-10 mx-auto mb-10"
      />
      <markdown
        [data]="changelogContent$ | async"
        ngPreserveWhitespaces
        emoji
      ></markdown>
      <style>
        h1 {
          @apply my-16;
        }
        h2 {
          margin-top: 25px;
          margin-bottom: 12px;
        }
        h3 {
          margin-top: 20px;
          margin-bottom: 10px;
        }
      </style>
    </div>
  `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeLogComponent implements AfterViewInit {
  @ViewChild('content') content: ElementRef;
  changelogContent$: Observable<string>;
  logoSrc: string;
  brandConfig: any;
  fleetLogo =
    'data:image/svg+xml;base64,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';

  constructor(
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private productConfigurationService: ProductConfigurationService,
    @Inject('env') private env: any
  ) {
    this.changelogContent$ = this.productConfigurationService.config$.pipe(
      takeUntilDestroyed(),
      switchMap((config: any) => {
        this.brandConfig = config;
        this.logoSrc = this.brandConfig.horizontalLogo;
        // this.logoSrc = this.fleetLogo;
        this.cdr.markForCheck();
        return this.http.get('assets/CHANGELOG.md', { responseType: 'text' });
      }),
      map((content) => this.clearLinks(content)),
      map((content) => {
        try {
          if (this.env?.envName === 'prod') {
            return this.removePrereleaseNotes(content);
          }
        } catch (error) {
          console.error(error);
        }
        return content;
      }),
      tap(() => {
        // Scroll to top after content is loaded
        setTimeout(() => {
          if (this.content?.nativeElement) {
            this.content.nativeElement.scrollTop = 0;
          }
        }, 1000);
      })
    );
  }

  ngAfterViewInit() {
    // Initial scroll attempt
    setTimeout(() => {
      if (this.content?.nativeElement) {
        this.content.nativeElement.scrollTop = 0;
      }
    }, 100);
  }

  private clearLinks(releaseNotes: string): string {
    // Regex to remove compare links but preserve the version number (e.g., [2.3.5](...))
    const compareLinkRegex = /\[([\d.]+)\]\(.*?\)/g;
    // Regex to remove commit links (e.g., [hash](...) or ([hash](...)))
    const commitLinkRegex = /\(\[.*?\]\(.*?\)\)/g;

    // Regex to remove Jira references (e.g., closes [#FW-1566](...))
    const jiraLinkRegex = /, closes \[#\w+-\d+\]\(.*?\)/g;

    // Remove compare links but keep the version numbers
    let cleanedNotes = releaseNotes.replace(compareLinkRegex, '$1');
    // Remove commit links and the surrounding parentheses entirely
    cleanedNotes = cleanedNotes.replace(commitLinkRegex, '');
    cleanedNotes = cleanedNotes.replace(jiraLinkRegex, '');
    return cleanedNotes;
  }

  private addLogoToHeader(releaseNotes: string): string {
    const logoMarkdown = `![Logo](${this.logoSrc})\n`;
    return releaseNotes.replace(
      /^#\s+Fleet\s+-\s+release\s+notes/,
      `${logoMarkdown}# Fleet - release notes`
    );
  }

  private removePrereleaseNotes(releaseNotes: string): string {
    return releaseNotes.replace(
      /^#{1,2} \[\d+\.\d+\.\d+-(?:staging|rc|alpha|beta|test\d*|bugfix|hotfix|dev)[^\]]*\].*(?:\n(?!#{1,2} \[).*)*\n*/gm,
      ''
    );
  }
}
